import React from 'react';
import { Ellipse, Group, Image, Text } from 'react-konva';
import Node, {
  NodeProps,
} from 'components/canvas/components/nodes/components/base-node';
import If from 'components/if-statement';
import NodeContextMenu from 'components/canvas/components/nodes/components/base-node/components/node-context-menu';
import GlobalLinksIndicator from 'components/canvas/components/nodes/components/base-node/components/global-links-indicator';
import SurfaceNodeEditIcon from 'components/canvas/components/nodes/components/surface-node/components/surface-node-edit-icon';
import SurfaceNodeRevokeAccessIcon from 'components/canvas/components/nodes/components/surface-node/components/surface-node-revoke-access-icon';
import WithCursor from 'components/canvas/components/with-cursor';
import useCurrentSurfacePermissions from 'components/canvas/hooks/use-current-surface-permissions';
import useSurfaceNodesFromCache from 'components/canvas/hooks/use-surface-nodes-from-cache';
import useNodeDimensionsOperations from 'components/canvas/hooks/use-node-dimensions-operations';
import useDragShadow from 'components/canvas/components/nodes/hooks/use-drag-shadow';
import useSurfacePermissions from 'components/canvas/hooks/use-surface-permissions';
import { useLoggedUser } from 'state/user';
import { doesNotInclude } from 'utils/js';
import { sortBy } from 'lodash';
import AliasIcon from 'styles/icons/copy-synced-icon.svg';
import SharedSurfaceIcon from 'styles/icons/shared-cell.svg';
import InProgressIcon from 'styles/icons/in-progress.png';
import { color } from 'styles/settings';
import { SubSurfaceNode } from 'graphql/types';
import { useOnSurfaceChangeOperations } from 'routes/surface/hooks/use-on-surface-change';
import SurfaceNodeCalenderIcon from './components/surface-node-calender-icon';
import SurfaceNodeRiskIcon from './components/surface-node-risk-icon';
import {
  useRiskMenuPosition,
  useRiskMenuPositionOperation,
} from 'state/canvas/selected-risk';

const aliasImage = new window.Image();
aliasImage.src = AliasIcon;

const sharedImage = new window.Image();
sharedImage.src = SharedSurfaceIcon;

const copyInProgressImage = new window.Image();
copyInProgressImage.src = InProgressIcon;

export interface SurfaceNodeProps extends NodeProps {
  navigateToSurface(surfaceId: string): void;
  node: SubSurfaceNode;
}

function SurfaceNode(props: SurfaceNodeProps) {
  const { node } = props;

  const [loggedUser] = useLoggedUser();

  const ellipseRef = React.useRef<any>(null);

  const nodesOnSurface = useSurfaceNodesFromCache();

  useDragShadow({
    ref: ellipseRef,
    node: node,
  });

  const { setSurfaceId } = useOnSurfaceChangeOperations();

  const { getNodeDimensionsByType } = useNodeDimensionsOperations();

  let referenceImage = isFirstSharedSurfaceReferenceOnSharedSurfaceRoot()
    ? sharedImage
    : aliasImage;

  if (node.isCopyInProgress) {
    referenceImage = copyInProgressImage;
  }

  const { canDeleteOwnedSurfaceNode } = useCurrentSurfacePermissions();

  const [riskPos, setRiskMenuPosition] = useRiskMenuPosition();

  const {
    canUpdateSurfaceNode,
    canReadSurfaceNode,
    isSharedSurfaceReference,
    canCopySurfaceNode,
    canDeleteSurfaceNode,
    canCutSurfaceNode,
  } = useSurfacePermissions(node as any);

  const {
    isNodeContextMenuVisible,
    canLinkSurfaceNode,
  } = useCurrentSurfacePermissions();

  const canRead = canReadSurfaceNode();

  const { width, height } = getNodeDimensionsByType(node.type);

  function onClick() {
    const id = node.isReference ? node?.originalNode?.id : node.id;
    if (canRead && id) {
      setSurfaceId(id);
      props.navigateToSurface(id);
    }
  }

  function showSurfaceEditForm() {
    props.showNodeModal(node);
  }

  function showCalenderForm() {
    // props.showNodeModal(node);
  }

  function showRisk(event_) {
    const stage = event_.target.getStage();
    const pointerPosition = stage.getPointerPosition();
    const offset = { x: event_.target.attrs.x, y: event_.target.attrs.y };

    const imageClickX = pointerPosition.x + 30; // + offset.x;
    const imageClickY = pointerPosition.y - offset.y;

    console.table({ x: imageClickX, y: imageClickY });

    console.table({ ...event_.target });
    console.log('showRisk ', node.position);
    setRiskMenuPosition({ x: imageClickX, y: imageClickY });
  }

  const textMargin = node.isReference || node.isCopyInProgress ? 70 : 20;

  const textWidth = width - textMargin * 2;

  const RevokeAccessIcon = React.useMemo(
    () => <SurfaceNodeRevokeAccessIcon node={node} />,
    [],
  );

  function iconsRenderer({ icons }): React.ReactElement[] | null {
    const copyAction = canCopySurfaceNode() ? icons.copy : null;

    const canLinkAction = canLinkSurfaceNode() ? icons.link : null;

    const canCutAction = canCutSurfaceNode() ? icons.cut : null;

    const deleteAction =
      canDeleteSurfaceNode() || canDeleteOwnedSurfaceNode()
        ? icons.delete
        : null;

    const isInitiallySharedReference =
      isSharedSurfaceReference &&
      isFirstSharedSurfaceReferenceOnSharedSurfaceRoot();

    const collaboratorActions = [
      canLinkAction,
      copyAction,
      ...(isInitiallySharedReference ? [] : [canCutAction]),
    ].filter(Boolean);

    // console.log(' ICONS Renderere', isSharedSurfaceReference);

    if (isSharedSurfaceReference) {
      if (isFirstSharedSurfaceReferenceOnSharedSurfaceRoot()) {
        return [...collaboratorActions, RevokeAccessIcon].filter(Boolean);
      }

      return [...collaboratorActions, deleteAction].filter(Boolean);
    }

    if (canUpdateSurfaceNode()) {
      // console.log(' ICONS Renderere 2', isSharedSurfaceReference);
      const ownerIcons = [
        <SurfaceNodeEditIcon onClick={showSurfaceEditForm} />,

        ...(Object.values(icons) as React.ReactElement[]),
        // <SurfaceNodeCalenderIcon onClick={showCalenderForm} />,
      ];

      //@ts-ignore
      if (node.sharedSurfacesRoot || node.mySurfacesRoot) {
        // console.log(' ICONS Renderere 3', isSharedSurfaceReference);
        const filteredIcons = Object.entries(icons)
          .filter(([key]) => doesNotInclude(key, ['delete', 'copy', 'cut']))
          .map(([_, value]) => value) as React.ReactElement[];

        return [
          <SurfaceNodeEditIcon onClick={showSurfaceEditForm} />,
          ...filteredIcons,

          // <SurfaceNodeRiskIcon onClick={showRisk} />,
        ];
      }

      return ownerIcons;
    }

    // console.log(' ICONS Renderere 4', isSharedSurfaceReference);
    return [...collaboratorActions];
  }

  function isFirstSharedSurfaceReferenceOnSharedSurfaceRoot() {
    const [sharedSurfaceReference] = sortBy(
      nodesOnSurface.filter(
        (n) =>
          n.isReference &&
          n.createdBy === loggedUser?.id &&
          n.ownedBy !== loggedUser?.id &&
          n.name === node.name,
      ),
      (node) => node.createdAt,
    );

    return (
      node?.surface?.sharedSurfacesRoot &&
      sharedSurfaceReference?.id === node?.id
    );
  }

  // console.log('SURFACE NODE', node);

  return (
    <Node {...props} width={width} height={height} onClick={onClick}>
      {({ isSelected }) => (
        <Group offsetY={-45}>
          <GlobalLinksIndicator node={node} x={width} />
          <WithCursor type={canRead ? 'pointer' : 'not-allowed'}>
            <Ellipse
              opacity={canRead ? 1 : 0.5}
              ref={ellipseRef}
              offsetX={-145}
              offsetY={-40}
              fill="#F5F5F5"
              radiusX={1}
              radiusY={1}
              width={width}
              height={height}
              stroke-width={'2px'}
              {...(isSelected ? { stroke: color.brand.greenDark } : {})}
            />
          </WithCursor>
          <Group>
            {(node.isReference || node.isCopyInProgress) && (
              <Image
                image={referenceImage}
                x={20}
                width={40}
                height={40}
                offsetY={-25}
              />
            )}
            <Text
              x={textMargin}
              offsetY={-30}
              align="center"
              verticalAlign="middle"
              width={
                node.isReference || node.isCopyInProgress
                  ? textWidth + 40
                  : textWidth
              }
              text={node.name}
              fill={color.neutral.black}
              fontFamily="'Montserrat'"
              fontStyle="bold"
              fontSize={26}
              wrap="none"
              ellipsis
            />
            {node.rating && (
              <Text
                // x={textMargin}
                x={200}
                stroke={color.neutral.black}
                strokeWidth={1}
                offsetY={15}
                align="top"
                verticalAlign="right"
                width={50}
                text={`${node.rating}*`}
                fill={color.brandIM.yellow}
                fontFamily="'Montserrat'"
                fontStyle="bold"
                fontSize={28}
                wrap="none"
                ellipsis
              />
            )}
          </Group>
          <If condition={isNodeContextMenuVisible(node)}>
            <NodeContextMenu
              node={node}
              width={width}
              height={height}
              hardDelete={isSharedSurfaceReference}
              icons={iconsRenderer}
            />
          </If>
        </Group>
      )}
    </Node>
  );
}

export default SurfaceNode;
